import { Link } from "react-router-dom";
import { classNames } from "../helpers";
import {
  ArrowRightIcon,
  MagnifyingGlassIcon,
  PlusIcon,
} from '@heroicons/react/24/outline';

const Button = (props) => {
  const {
    to,
    type,
    text,
    icon,
    onClick,
  } = props;

  const btnColors = {
    primary: 'bg-artfulRed hover:bg-artfulRed-dark text-white transition-all duration-300 ease-in-out',
    secondary: 'bg-white hover:bg-gray-200 text-black transition-all duration-300 ease-in-out'
  };

  const icons = {
    'right-arrow': ArrowRightIcon,
    'search': MagnifyingGlassIcon,
    'new': PlusIcon
  };
  const hasIcon = !!icon && Object.keys(icons).includes(icon);
  const IconComponent = icons[icon];

  const MainComponent = !!to ? Link : 'button';

  return (
    <MainComponent
      to={to}
      type={type}
      onClick={onClick}
      className={classNames(
        btnColors[type],
        icon === 'right-arrow' ? 'transform hover:translate-x-1' : '',
        'flex items-center justify-center px-3 py-2.5 rounded-md text-sm whitespace-nowrap'
      )}>
      {
        hasIcon ? (
          <>
            { text && <span className="mr-2">{ text }</span> }
            <IconComponent className="w-4 h-4" />
          </>
        ) : text
      }
    </MainComponent>
  )
};

Button.defaultProps = {
  type: 'primary',
}

export default Button;
